import type { Locale } from '@quoter/shared/locale'
import { productDictionaries, type CoreStrings } from '@quoter/web-core'
import { t as en, type ProductStrings } from './en'
import { pt } from './pt'
import { PRODUCT_NAME } from '@/lib/product'

/** Everything useI18n() hands out here: the platform's strings plus LowFodmaps's. */
export type Strings = CoreStrings & ProductStrings

export const DICTIONARIES: Record<Locale, Strings> = productDictionaries(PRODUCT_NAME, { en, pt })
